import type { Permission } from '@/permissions/permissions.catalog';
import { CATALOGUE_RIGHTS } from '@/permissions/route-rights';

export const INTENT = 'Where you connect.';

export const DESCRIPTION =
  'People, places and services beyond your own boat. Everything here can also be reached pre-filtered from the thing that needs it — an equipment item, a short-handed role, or a leg of a trip.';

export type DiscoverDestination = {
  label: string;
  to: string;
  blurb: string;
  /**
   * The rights the destination's own route guard opens on, any-of. Given them, a card is
   * only drawn where following it leads somewhere: a plan-locked one keeps its place with a
   * padlock and lands on the placeholder, and one the viewer could not reach at all is left
   * out rather than bouncing them to the dashboard.
   */
  anyOf?: readonly Permission[];
};

/**
 * The provider list's real path. The standalone `/service-providers` route
 * still exists but is gated on the same rights, so anything linking a crew user
 * to the catalogue links here.
 */
export const DISCOVER_PROVIDERS_ROUTE = '/discover/providers';

/** The hiring market's path — the list a crew CV hangs off. */
export const DISCOVER_CREW_ROUTE = '/discover/crew';

/** Vacancies vessels have posted — the other side of the hiring market. */
export const DISCOVER_VACANCIES_ROUTE = '/discover/vacancies';

export const DESTINATIONS: DiscoverDestination[] = [
  {
    label: 'Service Providers',
    to: DISCOVER_PROVIDERS_ROUTE,
    blurb: 'Yards, engineers and specialists, filterable by category and location.',
    anyOf: CATALOGUE_RIGHTS,
  },
  {
    label: 'Marinas',
    to: '/discover/marinas',
    blurb:
      'Berths and facilities by port. Your home berth lives on your vessel’s profile, not here.',
    anyOf: CATALOGUE_RIGHTS,
  },
  {
    // The hiring market runs on `GetJobAds`, which every account holds — no gate.
    label: 'Crew for Hire',
    to: DISCOVER_CREW_ROUTE,
    blurb: 'The hiring market, separate from your own crew roster.',
  },
  {
    // Read on `GetJobAds` too, so like the crew market it carries no gate.
    label: 'Vacancies',
    to: DISCOVER_VACANCIES_ROUTE,
    blurb: 'Open positions on vessels, with what each one asks of a candidate.',
  },
];
